import { render, staticRenderFns } from "./CuHuisarts.vue?vue&type=template&id=0e71e931&scoped=true"
import script from "./CuHuisarts.vue?vue&type=script&lang=js"
export * from "./CuHuisarts.vue?vue&type=script&lang=js"
import style0 from "./CuHuisarts.vue?vue&type=style&index=0&id=0e71e931&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e71e931",
  null
  
)

export default component.exports